import { pb } from '../../../shared/api/pocketbase';
import type { IntScorozvon, IntScorozvonMember } from './types';

export const fetchIntScorozvonList = () =>
  pb.collection('intScorozvon').getFullList<IntScorozvon>({
    sort: '-created',
    expand: 'managerId',
    fields: 'id,groupName,managerId,expand.managerId.name,expand.managerId.email',
  });

export const createIntScorozvon = (data: { groupName: string; managerId: string }) =>
  pb.collection('intScorozvon').create<IntScorozvon>(data);

export const updateIntScorozvon = (id: string, data: { groupName: string; managerId: string }) =>
  pb.collection('intScorozvon').update<IntScorozvon>(id, data);

export const deleteIntScorozvon = (id: string) =>
  pb.collection('intScorozvon').delete(id);

export const fetchIntScorozvonMembers = (groupId: string) =>
  pb.collection('intScorozvonMembers').getFullList<IntScorozvonMember>({
    filter: `groupId = "${groupId}"`,
    expand: 'userId',
    fields: 'id,userId,number,expand.userId.name,expand.userId.email',
  });

export const fetchAllIntScorozvonMembers = () =>
  pb.collection('intScorozvonMembers').getFullList<IntScorozvonMember>();

export const createIntScorozvonMember = (data: { groupId: string; userId: string; number: number }) =>
  pb.collection('intScorozvonMembers').create<IntScorozvonMember>(data, { requestKey: null });

export const deleteIntScorozvonMember = (id: string) =>
  pb.collection('intScorozvonMembers').delete(id, { requestKey: null });

// Сохранение записи одним batch-запросом: обновление/создание записи + пересоздание участников.
// Для 'add' запись создаётся отдельным запросом (нужен её id для участников), всё остальное — один batch.
export const saveIntScorozvon = async (params: {
  mode: 'add' | 'edit';
  id?: string;
  data: { groupName: string; managerId: string };
  members: { userId: string; number: number }[];
  removeMemberIds: string[];
}): Promise<string> => {
  const { mode, id, data, members, removeMemberIds } = params;

  let recordId = id ?? '';
  if (mode === 'add') {
    const record = await createIntScorozvon(data);
    recordId = record.id;
  }

  const batch = pb.createBatch();
  let count = 0;
  if (mode === 'edit') { batch.collection('intScorozvon').update(recordId, data); count++; }
  removeMemberIds.forEach(mid => { batch.collection('intScorozvonMembers').delete(mid); count++; });
  members.forEach(m => { batch.collection('intScorozvonMembers').create({ groupId: recordId, userId: m.userId, number: m.number }); count++; });
  if (count) await batch.send();

  return recordId;
};
